module.exports = __webpack_public_path__ + "Gary Tiu-23860f40.png";